var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 388 140",
    style: {
      enableBackground: "new 0 0 388 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000076570856873429454240000016756519054719863707_);fill:url(#SVGID_00000170257258315577622060000002618118596293583764_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M8.2,7.3h33.6v96.6h50v27H8.2V7.3z M138.8,130.9h-33.6V7.3h33.6V130.9z M213.9,94.5h1l25.4-87.2h37.9 l-40.8,123.6h-45.9L150.7,7.3h37.9L213.9,94.5z M290,7.3h89.1v27h-55.5v21.2h50.9v27h-50.9v21.2h55.3v27H290V7.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152966622416447089010000013541671350080604853_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183959330240276260380000016358554410260137139_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 68,
    x2: 383,
    y2: 68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E20E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#875CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A6DFF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000152966622416447089010000013541671350080604853_)",
      fill: "url(#SVGID_00000183959330240276260380000016358554410260137139_)"
    },
    width: 383,
    height: 136
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveText);
export default __webpack_public_path__ + "static/media/live_text.c43b4e044877a0f5f8225afd688cf642.svg";
export { ForwardRef as ReactComponent };